import { useState } from "react";
import { Link } from "react-router-dom";
import ArticleCard from "@/components/base/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";
import { articles } from "@/mocks/articles";
import { topics } from "@/mocks/topics";

const filters = [
  { id: "all", name: "全部" },
  ...topics.map((topic) => ({ id: topic.id, name: topic.name })),
];

export default function FeaturedFeed() {
  const [active, setActive] = useState("all");

  const list =
    active === "all"
      ? articles
      : articles.filter((article) => article.categoryId === active);

  const feature = list[0];
  const rest = list.slice(1);

  return (
    <section id="feed" className="bg-background-100 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <SectionHeading
            kicker="精选内容"
            title="正在被讨论的观察笔记"
            desc="按话题筛选，快速找到你关心的方向。每篇都尽量把来龙去脉讲清楚，看完心里有数。"
          />

          <div className="shrink-0 rounded-full bg-background-200/70 p-1 flex flex-wrap gap-1">
            {filters.map((filter) => (
              <button
                key={filter.id}
                type="button"
                onClick={() => setActive(filter.id)}
                className={`px-4 py-2 rounded-full text-sm font-label transition-colors cursor-pointer whitespace-nowrap ${
                  active === filter.id
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>

        {feature ? (
          <>
            <div className="mt-8">
              <ArticleCard article={feature} variant="feature" />
            </div>

            {rest.length > 0 && (
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {rest.slice(0, 6).map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            )}

            <div className="mt-8 text-center">
              <Link
                to={`/topic/${active === "all" ? topics[0].id : active}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300/80 text-foreground-800 text-sm font-label font-medium hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                进入更多分类内容
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </>
        ) : (
          <p className="mt-10 text-center text-sm text-foreground-500 font-label">
            该分类暂时还没有内容，换一个方向看看吧。
          </p>
        )}
      </div>
    </section>
  );
}